import React from 'react'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import injectJss from 'react-jss'

const styleSheet = theme => ({
    container: {
        zIndex: 9999,
        position: 'fixed',
        right: 3,
        bottom: 2,
        color: 'rgba(255,255,255,.2)',
        fontSize: '13px',
        fontWeight: 'normal',
        textAlign: 'right',
        pointerEvents: 'none',
        [theme.breakpoints.down('xs')]: {
            position: 'initial',
            right: 'initial',
            bottom: 'initial',
            textAlign: 'initial',
            color: theme.palette.common.white,
        },
    },
})

const style = injectJss(styleSheet)

const AppVersionDisplay = ({ classes, appVersion }) => <div className={classes.container}>v{appVersion}</div>

AppVersionDisplay.defaultProps = {
    appVersion: '0.0.0',
}

export default compose(
    style,
    pure
)(AppVersionDisplay)
